import {Box, Button, Stack} from '@mui/material';
import React from 'react';

import {EmptySearchState} from 'presentation/components';

import {GuidesEnum, QueryParamsEnum} from 'presentation/constants';
import {useLocationStore} from 'presentation/pages/private/store/locationStore';
import {FlowType} from 'presentation/pages/private/store/locationStore/constants';
import {translations} from 'presentation/translations-new';
import {getUserInfoFromToken} from 'presentation/utils';
import {useNavigate} from 'react-router-dom';
import {EmptyStateProps} from './types';

const {changeLocation} = translations['pt-br'].commons;

export function EmptyState({flowType, title, description}: EmptyStateProps) {
	const navigate = useNavigate();

	const cdPessoaC = getUserInfoFromToken().cdPessoa;
	const getLocation = useLocationStore(state => state.getLocation);
	const selectedLocation = getLocation(cdPessoaC, flowType);
	const {cdUf, nmUf} = selectedLocation.state;

	const pathCitySelection = `${flowType === FlowType.ODONTO_GUIDE ? GuidesEnum.SERVICE_NETWORK_ODONTO_FLOW_CITY : GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_CITY}?${QueryParamsEnum.UF_CODE}=${cdUf}&${QueryParamsEnum.UF_NAME}=${nmUf}`;

	const handleChangeLocation = () => {
		navigate(pathCitySelection);
	};

	return (
		<Box p={0}>
			<EmptySearchState title={title} description={description}>
				<Stack gap={2}>
					<Button variant="contained" size="large" onClick={handleChangeLocation}>
						{changeLocation}
					</Button>
				</Stack>
			</EmptySearchState>
		</Box>
	);
}
